"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Advertisement.css");
var Label_1 = require("../../atoms/Label/Label");
var Button_1 = require("../../atoms/Button/Button");
var ButtonProps_1 = require("../../atoms/Button/ButtonProps");
/**
 * The purpose of the component is to host seller tag unit for a publisher.
 * It use App Nexus Api java script based solution with tag configuration in below format.
 *
 * @visibleName Advertisement beta
 */
var Advertisement = /** @class */ (function (_super) {
    __extends(Advertisement, _super);
    function Advertisement(props) {
        var _this = _super.call(this, props) || this;
        _this.loadScript = function (src, window, doc) {
            if (window && doc && !window.adsScriptLoaded) {
                return new Promise(function (resolve, reject) {
                    var script = doc.createElement("script");
                    script.src = src;
                    script.async = true;
                    script.defer = true;
                    script.addEventListener("load", function () {
                        window.adsScriptLoaded = true;
                        resolve();
                    });
                    script.addEventListener("error", function (e) {
                        reject(e);
                    });
                    document.body.appendChild(script);
                });
            }
            else {
                return new Promise(function (resolve, reject) {
                    resolve();
                });
            }
        };
        _this.forSingleSessionChange = function () {
            // Handle single session opt outs
        };
        _this.forMultiSessionChange = function () {
            // Handle multiple session opt outs
        };
        _this.findBreakPoint = function (config) {
            var noOfConfig = config.length;
            var breakpointTag;
            config.sort(function (A, B) {
                if (B.breakpoint > A.breakpoint) {
                    return 1;
                }
                else if (A.breakpoint === B.breakpoint) {
                    return 0;
                }
                else {
                    return -1;
                }
            });
            if (window.innerWidth <= config[noOfConfig - 1].breakpoint) {
                breakpointTag = config[noOfConfig - 1];
            }
            else if (window.innerWidth >= config[0].breakpoint) {
                breakpointTag = config[0];
            }
            else {
                breakpointTag = config.find(function (tag) {
                    return tag.breakpoint === window.innerWidth;
                });
                // Find Nearest config
                if (!breakpointTag) {
                    config.forEach(function (tag) {
                        if (!breakpointTag) {
                            breakpointTag = tag;
                        }
                        else {
                            if (window.innerWidth <= breakpointTag.breakpoint &&
                                window.innerWidth >= tag.breakpoint) {
                                breakpointTag = tag;
                            }
                        }
                    });
                }
            }
            return breakpointTag;
        };
        _this.windowWaiter = function () {
            if (typeof window !== 'undefined' && window) {
                var win_1 = window;
                var doc = document;
                clearInterval(_this.interval);
                _this.loadScript("//acdn.adnxs.com/ast/ast.js", win_1, doc).then(function (e) {
                    var apntag = win_1 && win_1.apntag ? win_1.apntag : {};
                    if (_this.props.options && _this.props.options.debug) {
                        apntag.debug = true;
                    }
                    apntag.anq = apntag.anq || [];
                    // apntag.anq.push(() => {
                    var globalOptions = {};
                    globalOptions = {
                        friendlyPageName: window.ddo.getVar('page.pageInfo.friendlyPageName'),
                        fullUrl: window.ddo.getVar('page.location._addressBarFullURL'),
                    };
                    apntag.setPageOpts(__assign({ member: _this.props.data.adConfiguration.memberId }, globalOptions));
                    var currentTag = _this.findBreakPoint(_this.props.data.adConfiguration.tags);
                    _this.setState(function () { return ({
                        currentBreakpoint: currentTag.breakpoint,
                        selectedTag: currentTag,
                    }); });
                    if (currentTag) {
                        _this.setState(function () { return ({
                            noBidShown: false,
                        }); });
                        apntag.defineTag(__assign(__assign({}, currentTag.customProps), { tagId: Number(currentTag.tagId), targetId: _this.state.targetId }));
                    }
                    // Let us add event for the tag
                    _this.adLoadHandler();
                    apntag.onEvent('adNoBid', _this.state.targetId, function (adNoBid, adObj) {
                        _this.noBidHandler(_this.state.targetId);
                        _this.logMessage('AttMonetization:: no bid for.....' + _this.state.targetId, 'info');
                    });
                    // ECAP-19889
                    // apntag.onEvent('adAvailable', this.state.targetId, (adNoBid: any, adObj: any) => {
                    //     this.logMessage('AttMonetization:: adAvailable on.....' + this.state.targetId, 'info');
                    //     this.adLoadHandler();
                    // });
                    apntag.onEvent('adLoaded', _this.state.targetId, function (adObj) {
                        _this.logMessage('AttMonetization:: adLoaded on.....' + _this.state.targetId, 'info');
                    });
                    apntag.loadTags();
                    apntag.showTag(_this.state.targetId);
                }).catch(function (e) {
                    _this.logMessage('AttMonetization:: app nexus script loading failed..', 'error', e);
                    _this.setState(function () { return ({
                        adEnabled: false,
                    }); });
                });
            }
        };
        _this.state = {
            adEnabled: _this.props.data.enableAdvertisement !== undefined ? _this.props.data.enableAdvertisement : true,
            containerId: _this.props.id,
            heading: "" + (_this.props.data.advHeading ? _this.props.data.advHeading : 'Advertisement'),
            noBidShown: false,
            orientation: 'PORTRAIT',
            rptDtmEvents: _this.props.options && _this.props.options.reportAnalticsEvents ?
                _this.props.options.reportAnalticsEvents : false,
            showOptOutModal: false,
            targetId: _this.props.data.adConfiguration.targetId,
            userCtrl: (_this.props.options ?
                (_this.props.options.userCntrs ?
                    _this.props.options.userCntrs :
                    {
                        closeAd: false,
                        optOutCh: false,
                    }) :
                {
                    closeAd: false,
                    optOutCh: false,
                }),
        };
        _this.resizeHandler = _this.resizeHandler.bind(_this);
        _this.adTestHandler = _this.adTestHandler.bind(_this);
        _this.userCtrCloseAd = _this.userCtrCloseAd.bind(_this);
        _this.userCtrOptOut = _this.userCtrOptOut.bind(_this);
        _this.handleAnalyticsEvents = _this.handleAnalyticsEvents.bind(_this);
        _this.adLoadHandler = _this.adLoadHandler.bind(_this);
        _this.clickHandler = _this.clickHandler.bind(_this);
        _this.logMessage = _this.logMessage.bind(_this);
        return _this;
    }
    // Lifecycle hooks
    Advertisement.prototype.componentDidMount = function () {
        try {
            if (this.state.adEnabled ||
                (window && typeof window.adobe !== 'undefined' &&
                    typeof window.adobe.target.showAdvertisements !== 'undefined' &&
                    window.adobe.target.showAdvertisements)) {
                this.interval = setInterval(this.windowWaiter, 100);
                if (window) {
                    window.addEventListener('resize', this.resizeHandler);
                    window.document.getElementById(this.state.targetId).addEventListener('click', this.clickHandler);
                }
            }
            if (window && (typeof window.adobe !== 'undefined')) {
                window.addEventListener('at-content-rendering-succeeded', this.adTestHandler);
            }
        }
        catch (e) {
            this.logMessage('AttMonetization:: event registering failed..', 'error', e);
        }
    };
    Advertisement.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.state.heading !== nextState.heading ||
            this.state.containerId !== nextState.containerId ||
            this.state.adEnabled !== nextState.adEnabled ||
            this.state.userCtrl !== nextState.userCtrl ||
            this.state.showOptOutModal !== nextState.showOptOutModal) {
            var currentState_1 = Object.assign({}, this.state, {
                adEnabled: nextState.adEnabled,
                containerId: nextState.containerId,
                heading: nextState.heading,
                showOptOutModal: nextState.showOptOutModal,
                userCtrl: nextState.userCtrl,
            });
            this.setState(function () { return (__assign({}, currentState_1)); });
            this.windowWaiter();
            return true;
        }
        else {
            return false;
        }
    };
    Advertisement.prototype.render = function () {
        if (this.state.adEnabled) {
            return (React.createElement("div", { className: this.adContainerClasses(), tabIndex: 0, "aria-label": this.state.heading, id: this.state.containerId },
                (this.state.userCtrl.closeAd || this.state.userCtrl.optOutCh) &&
                    React.createElement("div", { className: styles.adClose },
                        this.state.userCtrl.optOutCh && React.createElement(Button_1.default, { data: { text: 'Ad Choice' }, events: { onClick: this.userCtrOptOut }, options: {
                                accessibility: 'Show Ad Choice Configuration',
                                color: ButtonProps_1.ButtonColor.COBALT,
                                role: ButtonProps_1.ButtonRole.BUTTON,
                                type: ButtonProps_1.ButtonType.SQUARE
                            } }),
                        this.state.userCtrl.closeAd &&
                            React.createElement(Button_1.default, { data: { text: 'X' }, events: { onClick: this.userCtrCloseAd }, options: { accessibility: 'Close The Advertisement',
                                    color: ButtonProps_1.ButtonColor.COBALT,
                                    role: ButtonProps_1.ButtonRole.BUTTON,
                                    type: ButtonProps_1.ButtonType.SQUARE } })),
                React.createElement(Label_1.default, { data: { text: this.state.heading }, options: {
                        className: styles.adLabel,
                    } }),
                React.createElement("div", { id: this.state.targetId }, "\u00A0")));
        }
        else {
            return null;
        }
    };
    Advertisement.prototype.componentWillUnmount = function () {
        if (window) {
            window.removeEventListener('ads-impression-click-reporting', this.clickHandler, false);
            window.removeEventListener('resize', this.resizeHandler, false);
            if (typeof window.adobe !== 'undefined') {
                try {
                    window.removeEventListener('at-content-rendering-succeeded', this.adTestHandler, false);
                }
                catch (e) {
                    this.logMessage('AttMonetization:: Adobe Target event de-registering failed..', 'error', e);
                }
            }
        }
    };
    Advertisement.prototype.logMessage = function (log, type, exception) {
        if (this.props.options && this.props.options.debug) {
            switch (type) {
                case 'info':
                    // tslint:disable-next-line:no-console
                    console.info(log);
                    break;
                case 'warn':
                    // tslint:disable-next-line:no-console
                    console.warn(log);
                    break;
                case 'error':
                    // tslint:disable-next-line:no-console
                    console.error(log, exception);
                    break;
                default:
                    // tslint:disable-next-line:no-console
                    console.info(log);
            }
        }
    };
    // user control drivers
    Advertisement.prototype.userCtrCloseAd = function () {
        this.setState(function () { return ({
            adEnabled: false,
        }); });
    };
    Advertisement.prototype.userCtrOptOut = function () {
        this.setState(function () { return ({
            showOptOutModal: true,
        }); });
    };
    Advertisement.prototype.onOptOutModalClose = function () {
        this.setState(function () { return ({
            showOptOutModal: false,
        }); });
    };
    Advertisement.prototype.adContainerClasses = function () {
        var cls = [styles.advertisementPanel];
        return (this.props.options &&
            this.props.options.classNames &&
            this.props.options.classNames.mainContainer
            ? __spread(cls, [this.props.options.classNames.mainContainer]).join(' ') : cls.join(' '));
    };
    // Event Handlers
    Advertisement.prototype.adTestHandler = function (event) {
        if (typeof window.adobe !== 'undefined' &&
            typeof window.adobe.target.showAdvertisements !== undefined) {
            if (!this.state.adEnabled && window.adobe.target.showAdvertisements) {
                this.interval = setInterval(this.windowWaiter, 100);
                window.addEventListener('resize', this.resizeHandler);
                this.setState({
                    adEnabled: true,
                });
            }
        }
    };
    Advertisement.prototype.adLoadHandler = function () {
        try {
            if ('undefined' !== typeof window && 'undefined' !== typeof window.ddo) {
                // Report a impression to DTM
                this.logMessage('AttMonetization:: Reporting impression for analytics for attmonitization...', 'info');
                this.handleAnalyticsEvents('impression');
            }
            else {
                this.logMessage("AttMonetization:: [ad load DMF status= " + window.DataMappingInterface + "]" +
                    "custom analytics events not activated, so no link click is reported for attmonitization...", 'warn');
            }
            if (this.props.events !== undefined && this.props.events.adLoadHandler !== undefined) {
                this.props.events.adLoadHandler();
            }
        }
        catch (e) {
            // Place holder to handle error during impression data collection
            this.logMessage('AttMonetization:: error happened during impression data reporting -', 'error', e);
        }
    };
    Advertisement.prototype.resizeHandler = function (e) {
        var newBreakpoint = this.findBreakPoint(this.props.data.adConfiguration.tags);
        if (this.state.selectedTag &&
            this.state.currentBreakpoint !== newBreakpoint.breakpoint) {
            this.setState(function () { return ({
                currentBreakpoint: newBreakpoint.breakpoint,
                noBidShown: false,
            }); });
            this.interval = setInterval(this.windowWaiter, 100);
        }
    };
    Advertisement.prototype.clickHandler = function (e) {
        if ('undefined' !== typeof (window.ddo) && this.state.rptDtmEvents) {
            // Report a link click to DTM
            this.logMessage('AttMonetization:: Reporting link click for analytics for attmonitization...', 'info');
        }
        else {
            this.logMessage("AttMonetization:: [DMF status= " + window.DataMappingInterface + "]" +
                "custom analytics events not activated, so no link click is reported for attmonitization...", 'warn');
        }
        if (this.props.events.clickHandler) {
            this.props.events.clickHandler(e);
        }
    };
    Advertisement.prototype.noBidHandler = function (targetElementID) {
        if (!this.state.noBidShown) {
            this.setState(function () { return ({
                noBidShown: true,
            }); });
        }
        else {
            this.setState(function () { return ({
                adEnabled: false,
            }); });
        }
        if (this.props.events.clickHandler) {
            this.props.events.noBidHandler(targetElementID);
        }
    };
    Advertisement.prototype.handleAnalyticsEvents = function (type) {
        switch (type) {
            case 'click':
                // dataAttrs.push();
                break;
            case 'impression':
                var curPageFriendlyName = window.ddo.getVar('page.pageInfo.friendlyPageName');
                var impressionObj = {
                    componentName: 'banner',
                    componentOrder: '10',
                    contentFriendlyName: (curPageFriendlyName ?
                        curPageFriendlyName :
                        'No_Prior_PageLoad_' + this.state.targetId),
                    contentSku: 'RTB',
                    contentSystem: 'AppNexus',
                    inventorySpaceId: this.state.targetId,
                    slotOrder: '1',
                    variationId: 'Not Availabale',
                };
                window.DataMappingInterface.init({
                    additionaldata: impressionObj,
                    datatransform: false,
                    eventAction: 'impression',
                    eventCode: 'impression',
                });
                break;
            default:
                // Handling the default case - just log a message with warning
                this.logMessage("AttMonetization:: event of type " + type + " are not supported by current ads component !!!", 'warn');
        }
    };
    return Advertisement;
}(React.Component));
exports.default = Advertisement;
//# sourceMappingURL=Advertisement.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Advertisement/Advertisement.js
// module id = 1342
// module chunks = 8